import React from "react";
import ContentEditable from "react-contenteditable";
import "../../../../components/themes/feedmeonline.css";

const Title1 = (props) => {
  const handleChangeFunction = (element, event) => {
    const { blockKey, onContentChange } = props;
    if (event.target.value !== undefined) {
      onContentChange(blockKey, element, event.target.value);
    }
  };

  const {
    brandGuidelines,
    backgroundColor,
    subTitleColor,
    titleColor,
    subTitle,
    title,
    topSpacer,
    bottomSpacer,
    blockKey,
  } = props;

  return (
    <table
      key={blockKey}
      border="0"
      cellPadding="0"
      cellSpacing="0"
      width="100%"
      role="presentation"
    >
      <tbody>
        <tr>
          <td
            className="cs-sm-p-20 title1Wrapper"
            bgcolor={backgroundColor}
            style={{
              backgroundColor: backgroundColor,
              paddingTop: `${topSpacer}px`,
              paddingBottom: `${bottomSpacer}px`,
            }}
            valign="top"
          >
            <table
              border="0"
              cellPadding="0"
              cellSpacing="0"
              width="100%"
              role="presentation"
            >
              <tbody>
                <tr>
                  <td
                    className="cs-fb-font"
                    valign="top"
                    align="center"
                    style={{
                      color: subTitleColor,
                      fontFamily: brandGuidelines.fontStack.primary,
                      fontSize: brandGuidelines.p.size,
                      lineHeight: brandGuidelines.p.lineHeight,
                      fontWeight: brandGuidelines.p.fontWeight,
                      textAlign: "center",
                    }}
                  >
                    <ContentEditable
                      html={subTitle}
                      disabled={false}
                      onChange={(event) => {
                        handleChangeFunction("subTitle", event);
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td height="8" className="title1Spacer">
                    &nbsp;
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td
                    className="cs-fb-font"
                    valign="top"
                    align="center"
                    style={{
                      color: titleColor,
                      fontFamily: brandGuidelines.fontStack.primary,
                      fontSize: brandGuidelines.h2.size,
                      lineHeight: brandGuidelines.h2.lineHeight,
                      fontWeight: brandGuidelines.h2.fontWeight,
                      textAlign: "center",
                    }}
                  >
                    <ContentEditable
                      html={title}
                      disabled={false}
                      onChange={(event) => {
                        handleChangeFunction("title", event);
                      }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Title1;
